import React from "react";
import { FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";

function CeoMessage() {
  return (
    <>
      <div className="container overflow-hidden">
        <div className="row pt-3 pt-lg-0 m-0 g-4 align-items-center">
          <div className="col-12 col-lg-6  p-3 p-lg-5 pt-0" data-aos="zoom-in" data-aos-duration="1800" data-aos-once="true" data-aos-delay="400">
            <div className="h-100">
              <div className=" w-75 h-75 mx-auto">
                <img
                  src={require("../../Assets/Images/IMG-20250129-WA0001.jpg")}
                  alt="not found"
                  className="img-fluid w-100 h-100 object-fit-contain  shadow"

                />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 " data-aos="fade-right" data-aos-duration="1800" data-aos-once="true" data-aos-delay="400">
            <div className="h-100">
              <div
                className="font_stroke"
                data-aos="fade-up"
                data-aos-duration="1500"
                data-aos-once="true"
              >
                MD's Message
              </div>
              <div
                className="ftittle"
                data-aos="fade-down"
                data-aos-duration="1500"
                data-aos-once="true"
              >
                - Munia Thulaseedas
              </div>
              <div className="pt-4 pera">
                "At Tharayil Power, we’re not just creating solar solutions;
                we’re pioneering a movement towards a cleaner, greener Kerala.
                Our mission is to provide innovative solar solutions that
                empower communities and future-proof businesses. Every project
                we undertake reflects our commitment to sustainable energy and a
                brighter, more eco-friendly future."{" "}
              </div>
              <div className=" text-success fw-bold py-2">
                — Munia Thulaseedas, MD, Tharayil Power
              </div>
              <div style={{ width: 50 }} >
                {" "}
                <Link
                  to={
                    "https://www.linkedin.com/in/munia-das-0383871a"
                  }
                  target="_blank"
                  className="footericon text-center p-2 justify-content-center mx-1 d-flex text-decoration-none text-white linkicon"
                  style={{ backgroundColor: "#0077b5" }}
                >
                  <FaLinkedinIn />
                </Link>
              </div>
            </div>
          </div>

        </div>
        <div className="row p-0 m-0 g-4  mt-3 align-items-center">

          <div className="col-12 col-lg-6 pt-0 pt-lg-3 order-1 order-lg-0" data-aos="fade-left" data-aos-duration="1800" data-aos-once="true" data-aos-delay="400">
            <div className="h-100">
              <div
                className="font_stroke"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                CEO's Message
              </div>
              <div
                className="ftittle"
                data-aos="fade-down"
                data-aos-duration="1500"
              >
                - Thulaseedas T N
              </div>
              <div className="pt-4 pera">
                "Our goal at Tharayil Power is to make solar power simple, accessible, and valuable for every client we serve. From residential installations to large-scale commercial projects, we leverage cutting-edge technology and an expert team to deliver solutions that enhance efficiency, reduce costs, and support Kerala’s environmental goals."  {" "}
              </div>
              <div className=" text-success fw-bold py-2">
                — Thulaseedas T N, CEO, Tharayil Power
              </div>
              <div style={{ width: 50 }} >
                {" "}
                <Link
                  to={
                    "https://www.linkedin.com/in/thulaseedas-nandajan-19b21441"
                  }
                  target="_blank"
                  className="footericon text-center p-2 justify-content-center mx-1 d-flex text-decoration-none text-white linkicon"
                  style={{ backgroundColor: "#0077b5" }}
                >
                  <FaLinkedinIn />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 p-5 pt-0 pb-0 pb-lg-5 order-0 order-lg-1" data-aos="fade-right" data-aos-duration="1800" data-aos-once="true" data-aos-delay="400">
            <div className="h-100">
              <div className=" w-75 h-75 mx-auto">
                <img
                  src={require("../../Assets/Images/STAFF PHOTOS/CEO-removebg-preview.png")}

                  alt="not found"
                  className="img-fluid w-100 h-100 object-fit-contain  shadow"
                  style={{ backgroundColor: "rgb(206,230,250)" }}

                />
              </div>
            </div>
          </div>
        </div>
        <div className="row pt-3 pt-lg-0 m-0 g-2 align-items-center">
          <div className="text-center">              <div
            className="font_stroke"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-once="true"
          >
            manager
          </div>
            <div
              className="ftittle"
              data-aos="fade-down"
              data-aos-duration="1500"
              data-aos-once="true"
            >
              General manager saying

            </div></div>
          <div className="col-12 col-lg-6  p-3 p-lg-5 pt-0" data-aos="zoom-in" data-aos-duration="1800" data-aos-once="true" data-aos-delay="400">
            <div className="h-100">
              <div className=" h-100 mnx-auto">
                <img
                  src={require("../../Assets/Images/profile/Naufia Haju copy.jpg")}
                  alt="not found"
                  className="img-fluid mx-auto  p-4"

                />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 " data-aos="fade-right" data-aos-duration="1800" data-aos-once="true" data-aos-delay="400">
            <div className="h-100 ">

              <div className="pt-4 pera">
                At just 31 years old, Naufia Haju
                has already established herself as
                a passionate and hardworking
                leader in the renewable energy
                sector. With a career rooted in
                innovation and sustainability, she
                has been instrumental in shaping
                the growth of Tharayil Power &
                Energy Solutions (P) Ltd, a
                leading business-to-customer
                solar company.
              </div>
              <div className="pt-4 pera">
                Naufia began her journey with Tharayil Power Since inception, as a
                Project Manager. Her dedication, engineering expertise, and
                commitment to renewable energy quickly set her apart, earning her
                recognition within the organization. Over five transformative years, she
                spearheaded numerous successful projects that reflected her vision of a
                cleaner, greener future.  Her unwavering determination and leadership skills led to a well
                deserved promotion on August 7, 2024, when she took on the role of
                General Manager at Inventonex, a subsidiary of Tharayil Power &
                Energy Solutions. Inventonex focuses on business-to-business solar
                solutions, and Naufia’s appointment marks a new chapter in the
                company’s journey towards delivering cutting-edge renewable energy
                solutions to its partners.
              </div>
              <div className="pt-4 pera">
                A true "Passionate Engineer," Naufia embodies resilience, innovation,
                and excellence in the renewable energy landscape. As she continues to
                lead with vision and vigor, her journey inspires professionals and
                businesses to harness the power of solar energy for a sustainable
                tomorrow.
              </div>
              <div className=" text-success fw-bold py-2 pt-3 fs-4">
                — Naufia Haju
              </div>
              <div className="  fw-bold fs-4">
                A Trailblazer in Renewable Energy
              </div>
              <div style={{ width: 50 }} >
                {" "}
                <Link
                  to={
                    "https://www.linkedin.com/in/naufia-haju-795a05191"
                  }
                  target="_blank"
                  className="footericon text-center p-2 justify-content-center mx-1 mt-2 d-flex text-decoration-none text-white linkicon"
                  style={{ backgroundColor: "#0077b5" }}
                >
                  <FaLinkedinIn />
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default CeoMessage;
